module.exports = __webpack_public_path__ + "images/shimo/slide-list-d5c42824b20b7264c925f90274f4234a.png";